import type { Story } from '../types/storyblok'

interface PageTypeSchema {
  story: Story
  canonical: string
}

export function usePageTypeSchema({ story, canonical }: PageTypeSchema) {
  if (!story.content.page_type) {
    return {
      schema: undefined,
    }
  }

  function schema() {
    const types = ['Article', 'BlogPosting', 'NewsArticle']
    const type = types.includes(story.content.page_type) ? story.content.page_type : undefined

    function normalizeSchemaImage() {
      const blocks = story.content?.body ?? []
      const heroBlock = blocks.find((block: { component: string }) => block.component === 'hero-block-v2')
      if (heroBlock?.smallAsset?.filename)
        return heroBlock.smallAsset.filename
      else
        return undefined
    }

    const image = normalizeSchemaImage()

    return {
      '@context': 'https://schema.org',
      '@type': type,
      'headline': story?.content?.seo?.title,
      'description': story?.content?.seo?.description,
      'datePublished': (story?.first_published_at?.slice(0, 10)),
      'dateModified': (story?.published_at?.slice(0, 10)),
      'publisher': {
        '@type': 'Organization',
        'name': 'Happy Socks',
        'logo': {
          '@type': 'ImageObject',
          'url': 'https://www.beta.happysocks.com/icons/logo-hs.svg',
        },
      },
      'mainEntityOfPage': {
        '@type': 'WebPage',
        '@id': canonical,
      },
      'image': image || undefined,
    }
  }

  return {
    schema: schema(),
  }
}
